<div class='attention'>
    <svg xmlns="http://www.w3.org/2000/svg" class='top left' viewBox="0 0 215 101" fill="none">
        <path d="M0 82.0994L16 101V0H0V82.0994Z" fill="#7A67FF"/>
        <path d="M93.4211 0L117 20L5 20V0L93.4211 0Z" fill="#7A67FF"/>
        <path d="M207.148 13.0001L214.797 20.0001L87.6301 20.0001V13.0001L207.148 13.0001Z" fill="#7A67FF"/>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" class='top right' viewBox="0 0 79 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M52.0363 0.000470161L35.6844 15.5821H52.0363L68.3883 0.000470161H52.0363Z" fill="#7A67FF"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.8192 0.000470161L9.46729 15.5821H25.8192L42.1712 0.000470161H25.8192Z" fill="#7A67FF"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M78.2535 0.000470161L61.9016 15.5821H78.2535V0.000470161Z" fill="#7A67FF"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.47955e-05 15.5816L16.352 -6.10352e-05H2.47955e-05V15.5816Z" fill="#7A67FF"/>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" class='bottom' viewBox="0 0 189 117" fill="none">
        <path d="M15.6511 117L0 101H189V117L15.6511 117Z" fill="#7A67FF"/>
        <path d="M189 15.6511L173 0V107.978H189V15.6511Z" fill="#7A67FF"/>
    </svg>

    <div class="outline">
        <div class="inner">
            <div class="title">필독</div>
            
            <ul>
                <li>
                    던전스쿼드 팀 빌딩 페이지에 오신것을 환영합니다.<br>
                    페이지를 원할하게 표시 및 이용하기 위해 쿠키를 사용합니다.<br>
                    해당 페이지를 계속 이용하려면 쿠키 사용에 <strong>동의</strong> 해야 합니다.
                </li>
                <li>
                    해당 페이지의 이미지(그래픽 에셋) 및 게임 데이터는 개발사인 <strong>게임코스터(GameCoaster)</strong>에 저작권이 있습니다.
                </li>
                <li>
                    비용적인 문제로 별도의 서버를 구매하여 구축하였습니다.<br>
                    서버가 불안정하기에 종종 다운됩니다. 접속이 안될 경우 제보 부탁드립니다.
                </li>
                <li>
                    문제가 되는 글이 있을 경우, 별도 경고 없이 <strong>삭제</strong> 될 예정입니다.<br>
                    예) 숫자만 있는 경우, 자음만 있는 경우, 알파벳 대충 쓴 경우 등등<br>
                    예) 욕설, 음란성, 정치적 등등<br>
                    예) 기타 문제되는 글
                </li>
                <li>
                    오류/오타/게시글 삭제는 (<a href="https://open.kakao.com/me/admin_turtle" rel="noopener noreferrer" target="_blank">제보</a>) 통해 요청해주세요.
                </li>
                <li>
                    제보 응답 결과 : (<a href="https://docs.google.com/spreadsheets/d/1p-1bCmv6j5ffmv4gqAakgGLH1wt2DfVzC5RdetkKkHo/edit?usp=sharing" rel="noopener noreferrer" target="_blank">클릭</a>)
                </li>
                <li>
                    페이지 가이드 : (<a href="https://lazeturtle.tistory.com/39" rel="noopener noreferrer" target="_blank">클릭</a>)
                </li>
                <li>
                    관리자 및 스텝은 페이지 이용자에게 금품을 <strong>요구 하지 않습니다.</strong>
                </li>

                
                <li>
                    <strong>개발 로드맵</strong> : 
                    기타 기능 추가 -> 상시 버그 수정 및 데이터 갱신
                </li>
            </ul>
        </div>
    </div>
</div>


<style lang="scss">
    .attention {
        width: calc(100% - 31px);
        max-width: 1200px;
        height: fit-content;
        margin: auto;
        margin-bottom: calc(50px - 16px);
        padding: 20px 16px 16px 15px;

        position: relative;

        svg {
            fill: none;
            position: absolute;

            &.top {
                &.left {
                    width: 215px;
                    height: 101px;
                    top: 0px;
                    left: 0px;
                }
                &.right {
                    width: 79px;
                    height: 16px;
                    top: 0px;
                    right: 16px;
                }
            }

            &.bottom {
                width: 189px;
                height: 117px;
                bottom: 0px;
                right: 0px;
            }
        }

        .outline {
            /* padding - border - left width - right  width */
            width: calc(100% - 40px - 6px);
            height: calc(100%);
            margin: 0px 0px 0px 0px;
            padding: 20px;
            border: 3px solid $cl3;
            position: flex;

            .inner {
                background: rgba($color: $cl3, $alpha: 0.3);
                height: fit-content;

                .title {
                    font-family: aggro;
                    font-weight: 400;
                }
                ul {
                    margin: 0;
                    margin-top: 20px;
                    padding-left: 22px;

                    li {
                        margin-top: 9px;
                        word-break: keep-all;

                        strong {
                            background-color: $cl4;
                            padding: 0 4px;
                            color: $cl6;
                            font-family: aggro;
                        }

                        a {
                            padding: 4px;
                            border-radius: $br1;
                            color: $cl4;
                            font-family: aggro;

                            &:hover {
                                background: $cl5;
                                color: $cl2;
                            }
                        }
                    }
                }

                @include mobile {
                    width: calc(100% - 30px);
                    padding: 15px;

                    .title {
                        font-size: 18px;
                    }
                    ul {
                        font-size: 12px;
                    }
                }

                @include tablet {
                    width: calc(100% - 60px);
                    padding: 30px;

                    .title {
                        font-size: 30px;
                    }
                    ul {
                        font-size: 15px;
                    }
                }

                @include desktop {
                    width: calc(100% - 60px);
                    padding: 30px;

                    .title {
                        font-size: 30px;
                    }
                    ul {
                        font-size: 15px;
                    }
                }

                @include wide {
                    width: calc(100% - 60px);
                    padding: 30px;

                    .title {
                        font-size: 30px;
                    }
                    ul {
                        font-size: 15px;
                    }
                }
            }
        }
    }
</style>